<template>
    <PageWrapper>
        <template #headline>
            <fa icon="fa-users" />
            {{ $t('accounts') }}
        </template>

        <AccountsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@partials/pages/PageWrapper.vue'
import AccountsTable from '@src/partials/accounts/AccountsTable.vue'
</script>
